import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SHOW_MESSAGE_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER_VERIFICATION,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
} from "constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  initURL: "",
  success: true,
  authUser: localStorage.getItem("user_id"),
  isEmailVerified: localStorage.getItem("isEmailVerified"),
  isPhoneVerified: localStorage.getItem("isPhoneVerified"),
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload.authUser,
        userUuid: action.payload.uuid,
      };
    }
    case SIGNIN_USER_VERIFICATION: {
      return {
        ...state,
        // loader: false,
        isEmailVerified: action.payload.email,
        isPhoneVerified: action.payload.phone,
        phone: action.payload.phoneNumber,
      };
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        initURL: "/",
        loader: false,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
        success: false,
      };
    }
    case SHOW_MESSAGE_SUCCESS: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
        success: true,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false,
      };
    }

    // case SIGNIN_GOOGLE_USER_SUCCESS: {
    //   return {
    //     ...state,
    //     loader: false,
    //     authUser: action.payload
    //   }
    // }
    // case SIGNIN_FACEBOOK_USER_SUCCESS: {
    //   return {
    //     ...state,
    //     loader: false,
    //     authUser: action.payload
    //   }
    // }
    // case SIGNIN_TWITTER_USER_SUCCESS: {
    //   return {
    //     ...state,
    //     loader: false,
    //     authUser: action.payload
    //   }
    // }
    // case SIGNIN_GITHUB_USER_SUCCESS: {
    //   return {
    //     ...state,
    //     loader: false,
    //     authUser: action.payload
    //   }
    // }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }

    default:
      return state;
  }
};
